import { render, staticRenderFns } from "./DataConversionMVV.vue?vue&type=template&id=b0e13d4c&scoped=true&"
import script from "./DataConversionMVV.vue?vue&type=script&lang=js&"
export * from "./DataConversionMVV.vue?vue&type=script&lang=js&"
import style0 from "./DataConversionMVV.vue?vue&type=style&index=0&id=b0e13d4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e13d4c",
  null
  
)

/* custom blocks */
import block0 from "./DataConversionMVV.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports